// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../auth/AuthContext";
// import { useSessionStore } from "../../stores/sessionStore";
// import { api } from "../../config/middleware";
// import { API_GETSERVICEWITHPRODUCTS, API_CREATEBILL } from "../../config/api";

// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Container,
//   Row,
//   Col,
//   ModalFooter,
//   Label,
//   Table,
// } from "reactstrap";
// import Header from "components/Headers/Header";
// import Swal from "sweetalert2";

// const AddRecordOrderNoPackage = () => {
//   const sa = {
//     info: (text, title = "แจ้งเตือน") =>
//       Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
//     success: (text, title = "สำเร็จ") =>
//       Swal.fire({ icon: "success", title, text, confirmButtonText: "ตกลง" }),
//     error: (text, title = "เกิดข้อผิดพลาด") =>
//       Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
//   };

//   const navigate = useNavigate();
//   const location = useLocation();

//   // ---------- ข้อมูล session / org ----------
//   const { user } = useAuth();
//   const role = (
//     user?.role ||
//     localStorage.getItem("role") ||
//     "user"
//   ).toLowerCase();

//   const orgId = useSessionStore((s) => s.profile?.orgId);
//   const tnId = useSessionStore((s) => s.profile?.tnId);
//   const brId = useSessionStore((s) => s.profile?.brId);

//   // ---------- รับ customer จาก OrderBillOrg ----------
//   const navState = location.state || {};
//   const customerFromState = navState.customer || null;

//   const customerDisplay = customerFromState
//     ? `(${customerFromState.code}) - ${customerFromState.name}`
//     : "";

//   // ---------- form header ----------
//   const [form, setForm] = useState({
//     serviceId: "",
//     customerCode: customerFromState?.code || "",
//   });

//   // วันที่
//   const [receiveDate, setReceiveDate] = useState(""); // BRECEIVE
//   const [dueDate, setDueDate] = useState(""); // BDUEDATE

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setForm((s) => ({ ...s, [name]: value }));
//   };

//   // ---------- state สำหรับ service + product จาก API ----------
//   const [services, setServices] = useState([]);
//   const [loadingServices, setLoadingServices] = useState(false);
//   const [serviceError, setServiceError] = useState("");

//   const [selectedServiceId, setSelectedServiceId] = useState("");
//   const [productOptions, setProductOptions] = useState([]);

//   // โหลดบริการ + products จาก API_GETSERVICEWITHPRODUCTS (ส่ง ORGID)
//   useEffect(() => {
//     if (!orgId) return;
//     const fetchServices = async () => {
//       setLoadingServices(true);
//       setServiceError("");
//       try {
//         const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         setServices(arr);
//       } catch (e) {
//         console.error("API_GETSERVICEWITHPRODUCTS error:", e);
//         setServiceError(
//           e?.response?.data?.message || e?.message || "ไม่สามารถโหลดบริการได้"
//         );
//       } finally {
//         setLoadingServices(false);
//       }
//     };
//     fetchServices();
//   }, [orgId]);

//   // แปลง service เป็น options สำหรับ select
//   const serviceOptions = useMemo(
//     () =>
//       services.map((s) => ({
//         value: String(s.svId),
//         label: `(${s.svCode}) ${s.svName}`,
//         raw: s,
//       })),
//     [services]
//   );

//   // service ปัจจุบันที่เลือก + หน่วย
//   const currentService = useMemo(
//     () => services.find((s) => String(s.svId) === String(form.serviceId)),
//     [services, form.serviceId]
//   );

//   const currentUnit = currentService?.svUnit || "";
//   // เมื่อเลือกบริการ → set serviceId + productOptions
//   const onServiceChange = (e) => {
//     const value = e.target.value;
//     setSelectedServiceId(value);
//     setForm((s) => ({
//       ...s,
//       serviceId: value,
//     }));

//     const found = services.find((sv) => String(sv.svId) === String(value));
//     if (found && Array.isArray(found.products)) {
//       setProductOptions(found.products); // [{ pdId, pdCode, pdName, pdPrice }, ...]
//     } else {
//       setProductOptions([]);
//     }

//     // เคลียร์ฟอร์มย่อย + ตารางรายการ ทุกครั้งที่เปลี่ยนบริการ
//     setDetailProductId("");
//     setDetailQty("");
//     setDetailPrice("");
//     setDetails([]);
//   };

//   // ---------- ฟิลด์ย่อย: รายการสินค้า ----------
//   const [detailProductId, setDetailProductId] = useState(""); // pdId
//   const [detailQty, setDetailQty] = useState(""); // จำนวน
//   const [detailPrice, setDetailPrice] = useState(""); // ราคา (จาก pdPrice)
//   const [details, setDetails] = useState([]); // รายการทั้งหมด

//   // เมื่อเลือกสินค้า → เติมราคาอัตโนมัติจาก productOptions
//   const handleSelectProduct = (e) => {
//     const val = e.target.value; // pdId
//     setDetailProductId(val);

//     const found = productOptions.find((p) => String(p.pdId) === String(val));
//     if (found) {
//       setDetailPrice(Number(found.pdPrice || 0).toFixed(2));
//     } else {
//       setDetailPrice("");
//     }
//   };

//   // เพิ่มรายการ detail
//   const handleAddDetail = () => {
//     const qty = Number(detailQty);
//     const price = Number(detailPrice);

//     if (!detailProductId) return alert("กรุณาเลือกสินค้า");
//     if (!qty || qty <= 0) return alert("กรุณากรอกจำนวนให้ถูกต้อง");
//     if (!price || price <= 0) return alert("ราคาสินค้าไม่ถูกต้อง");

//     const product = productOptions.find(
//       (p) => String(p.pdId) === String(detailProductId)
//     );

//     setDetails((prev) => [
//       ...prev,
//       {
//         id: Date.now(),
//         pdId: product?.pdId,
//         pdCode: product?.pdCode,
//         productLabel: product?.pdName || "",
//         qty,
//         price,
//       },
//     ]);

//     // เคลียร์ input ย่อย
//     setDetailProductId("");
//     setDetailQty("");
//     setDetailPrice("");
//   };

//   const handleRemoveDetail = (id) => {
//     setDetails((prev) => prev.filter((d) => d.id !== id));
//   };

//   const handleChangeDetailQty = (id, value) => {
//     const qty = Number(value);
//     setDetails((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, qty: isNaN(qty) ? "" : qty } : item
//       )
//     );
//   };

//   const handleCancelAddRecordOrder = () => {
//     navigate("/order-orgs");
//   };

//   // (ยังไม่ทำ submit จริง เพราะโจทย์เน้นโชว์ข้อมูล + ดึงจาก API)
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("customerFromState:", customerFromState);
//     console.log("serviceId:", form.serviceId);
//     console.log("details:", details);
//     alert("ตัวอย่าง: ดูข้อมูลใน console.log ก่อนเชื่อม API บันทึกจริง");
//   };

//   const handleSaveBill = async () => {
//     try {
//       // ตรวจค่าพื้นฐานก่อน
//       if (tnId == null || orgId == null || brId == null) {
//         return sa.error("ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)");
//       }

//       if (!form.customerCode) {
//         return sa.info("กรุณาเลือกลูกค้า");
//       }

//       if (!form.serviceId) {
//         return sa.info("กรุณาเลือกแพ็คเกจ/บริการ");
//       }

//       if (!receiveDate || !dueDate) {
//         return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");
//       }

//       if (details.length === 0) {
//         return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
//       }

//       // แปลง details -> ITEMS ตามโครง API
//       const ITEMS = details
//         .filter((d) => d.pdId) // กันเคสข้อมูลหลุด
//         .map((d) => ({
//           pdId: d.pdId,
//           bdQty: Number(d.qty || 0),
//           pdPrice: Number(d.price || 0),
//         }))
//         .filter((it) => it.bdQty > 0); // กรอง qty ที่ไม่ถูกต้องออก

//       if (ITEMS.length === 0) {
//         return sa.info("ไม่พบรายการสินค้าที่สามารถเปิดบิลได้");
//       }

//       const payload = {
//         TNID: tnId,
//         ORGID: orgId,
//         BRID: brId,
//         CMCODE: form.customerCode,
//         SVID: form.serviceId, // ถ้าหลังบ้านต้องการเป็น number ค่อย Number(form.serviceId)
//         BRECEIVE: receiveDate,
//         BDUEDATE: dueDate,
//         DISCOUNT: 0,
//         VAT: 0,
//         ITEMS,
//       };

//       const res = await api.post(API_CREATEBILL, payload);
//       const ok = res?.data?.statustext === "SUCCESS";

//       if (!ok) {
//         console.error("CreateBill error:", res?.data);
//         return sa.error(res?.data?.message || "เปิดบิลไม่สำเร็จ");
//       }

//       // สำเร็จ
//       await sa.success(res?.data?.message || "เปิดบิลสำเร็จ");

//       // เคลียร์ฟอร์ม/กลับหน้า list (ตอนนี้ให้กลับหน้ารายการ)
//       navigate("/order-bill-org");
//     } catch (e) {
//       console.error("CreateBill exception:", e);
//       sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
//     }
//   };

//   return (
//     <>
//       <Header />
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xs="12">
//             <Card className="bg-secondary shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="8">
//                     <h6 className="mb-0">เปิดบิล (ลูกค้าไม่มีแพ็คเกจ)</h6>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody>
//                 <Form onSubmit={handleSubmit}>
//                   <h6 className="heading-small text-muted mb-4">
//                     ข้อมูลส่วนหัว
//                   </h6>
//                   <Row>
//                     {/* ลูกค้า จาก OrderBillOrg */}
//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           ลูกค้า
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           name="customer"
//                           value={customerDisplay}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* บริการ จาก API_GETSERVICEWITHPRODUCTS */}
//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           แพ็คเกจ
//                         </label>
//                         <Input
//                           id="serviceSelect"
//                           className="form-control-alternative"
//                           type="select"
//                           name="serviceId"
//                           value={form.serviceId}
//                           onChange={onServiceChange}
//                           required
//                           disabled={loadingServices || !!serviceError}
//                         >
//                           <option value="">
//                             {loadingServices
//                               ? "กำลังโหลดบริการ..."
//                               : serviceError || "-- เลือก --"}
//                           </option>
//                           {serviceOptions.map((o) => (
//                             <option key={o.value} value={o.value}>
//                               {o.label}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col lg="6" md="6">
//                       <FormGroup className="mb-0">
//                         <label className="form-control-label">
//                           วันที่รับผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={receiveDate}
//                           onChange={(e) => setReceiveDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                     <Col lg="6" md="6">
//                       <FormGroup className="mb-0">
//                         <label className="form-control-label">
//                           วันที่ส่งผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={dueDate}
//                           onChange={(e) => setDueDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />
//                   <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

//                   <Row>
//                     {/* สินค้า จาก products ของ service ที่เลือก */}
//                     <Col lg="4">
//                       <FormGroup>
//                         <label className="form-control-label">สินค้า</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="select"
//                           name="detailProductId"
//                           value={detailProductId}
//                           onChange={handleSelectProduct}
//                           disabled={productOptions.length === 0}
//                         >
//                           <option value="">
//                             {productOptions.length === 0
//                               ? "-- เลือกบริการก่อน --"
//                               : "-- เลือก --"}
//                           </option>
//                           {productOptions.map((p) => (
//                             <option key={p.pdId} value={p.pdId}>
//                               {p.pdName}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     {/* จำนวน */}
//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">จำนวน</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="number"
//                           min="1"
//                           value={detailQty}
//                           onChange={(e) => setDetailQty(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">หน่วย</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={currentUnit || ""}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* ค่าบริการ/ชิ้น (จาก pdPrice) */}
//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">
//                           ค่าบริการ/ชิ้น
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={detailPrice}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* ปุ่มเพิ่ม */}
//                     <Col lg="2">
//                       <FormGroup className="mb-0">
//                         <Label className="invisible">offset</Label>
//                         <Button
//                           color="info"
//                           onClick={handleAddDetail}
//                           className="w-100"
//                           type="button"
//                         >
//                           เพิ่ม
//                         </Button>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />

//                   {/* ตารางรายการ */}
//                   <Row>
//                     <Col lg="12">
//                       <div className="table-responsive">
//                         <Table
//                           responsive
//                           hover
//                           borderless
//                           className="table table-modern mb-0"
//                         >
//                           <thead className="thead-dark">
//                             <tr>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "50%" }}
//                               >
//                                 สินค้า
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 จำนวน
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 หน่วย
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 ค่าบริการ/ชิ้น
//                               </th>
//                               <th
//                                 className="text-right"
//                                 style={{ width: "20%" }}
//                               ></th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {details.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={4}
//                                   className="text-center text-muted"
//                                 >
//                                   ยังไม่มีรายการ
//                                 </td>
//                               </tr>
//                             ) : (
//                               details.map((d) => (
//                                 <tr key={d.id}>
//                                   <td>
//                                     <Input
//                                       type="text"
//                                       value={d.productLabel || ""}
//                                       readOnly
//                                       className="form-control-alternative"
//                                     />
//                                   </td>
//                                   <td className="text-center">
//                                     <Input
//                                       type="number"
//                                       min="0"
//                                       value={d.qty}
//                                       onChange={(e) =>
//                                         handleChangeDetailQty(
//                                           d.id,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="form-control-alternative"
//                                       style={{
//                                         maxWidth: 120,
//                                         margin: "0 auto",
//                                         textAlign: "center",
//                                       }}
//                                     />
//                                   </td>
//                                   <td>
//                                     <Input
//                                       type="text"
//                                       value={currentUnit || ""}
//                                       readOnly
//                                       className="form-control-alternative"
//                                     />
//                                   </td>
//                                   <td className="text-right">
//                                     <Input
//                                       type="text"
//                                       value={Number(d.price).toFixed(2)}
//                                       readOnly
//                                       disabled
//                                       className="form-control-alternative"
//                                       style={{
//                                         maxWidth: 140,
//                                         marginLeft: "auto",
//                                       }}
//                                     />
//                                   </td>
//                                   <td className="text-right">
//                                     <Button
//                                       color="danger"
//                                       onClick={() => handleRemoveDetail(d.id)}
//                                       type="button"
//                                     >
//                                       ลบ
//                                     </Button>
//                                   </td>
//                                 </tr>
//                               ))
//                             )}
//                           </tbody>
//                         </Table>
//                       </div>
//                     </Col>
//                   </Row>

//                   {/* ปุ่มบันทึก/ยกเลิก */}
//                   <ModalFooter className="px-0">
//                     <Button
//                       color="secondary"
//                       onClick={handleCancelAddRecordOrder}
//                       type="button"
//                     >
//                       ยกเลิก
//                     </Button>
//                     <Button
//                       color="primary"
//                       type="button"
//                       onClick={handleSaveBill}
//                     >
//                       เปิดบิล
//                     </Button>
//                   </ModalFooter>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </>
//   );
// };

// export default AddRecordOrderNoPackage;

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useSessionStore } from "../../stores/sessionStore";
import { api } from "../../config/middleware";
import {
  API_GETSERVICEWITHPRODUCTS,
  API_CREATEBILL,
  API_GETPRODUCTS,
  API_ADDPRODUCT,
  API_BUYSERVICEPACKAGE,
} from "../../config/api";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Label,
  Table,
} from "reactstrap";
import Header from "components/Headers/Header";
import Swal from "sweetalert2";

const AddRecordOrderNoPackage = () => {
  const sa = {
    info: (text, title = "แจ้งเตือน") =>
      Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
    success: (text, title = "สำเร็จ") =>
      Swal.fire({
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 2000,
      }),
    error: (text, title = "เกิดข้อผิดพลาด") =>
      Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
  };

  const navigate = useNavigate();
  const location = useLocation();

  // ---------- ข้อมูล session / org ----------
  const { user } = useAuth();
  const role = (
    user?.role ||
    localStorage.getItem("role") ||
    "user"
  ).toLowerCase();

  const orgId = useSessionStore((s) => s.profile?.orgId);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const brId = useSessionStore((s) => s.profile?.brId);

  // ---------- รับ customer จาก OrderBillOrg ----------
  const navState = location.state || {};
  const customerFromState = navState.customer || null;

  const customerDisplay = customerFromState
    ? `(${customerFromState.code}) - ${customerFromState.name}`
    : "";

  // ---------- form header ----------
  const [form, setForm] = useState({
    serviceId: "",
    customerCode: customerFromState?.code || "",
  });

  // วันที่
  const [receiveDate, setReceiveDate] = useState(""); // BRECEIVE
  const [dueDate, setDueDate] = useState(""); // BDUEDATE

  // ---------- state สำหรับ service + product จาก API ----------
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [serviceError, setServiceError] = useState("");

  const [products, setProducts] = useState([]); // สินค้าจาก API_GETPRODUCTS (cmcode ก่อน ถ้าไม่มีค่อย ORG)
  const [loadingProducts, setLoadingProducts] = useState(false);

  const [detailWeight, setDetailWeight] = useState(""); // น้ำหนัก/ชิ้น (ของฟอร์มเพิ่มรายการแบบ API)
  const [isSmall, setIsSmall] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsSmall(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // โหลดบริการ จาก API_GETSERVICEWITHPRODUCTS (ส่ง ORGID)
  useEffect(() => {
    if (!orgId) return;
    const fetchServices = async () => {
      setLoadingServices(true);
      setServiceError("");
      try {
        const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        setServices(arr);
      } catch (e) {
        console.error("API_GETSERVICEWITHPRODUCTS error:", e);
        setServiceError(
          e?.response?.data?.message || e?.message || "ไม่สามารถโหลดบริการได้",
        );
      } finally {
        setLoadingServices(false);
      }
    };
    fetchServices();
  }, [orgId]);

  // โหลดสินค้า: ส่ง CMCODE=cmcode ก่อน ถ้าไม่มีค่อยใช้ CMCODE=ORG
  useEffect(() => {
    if (!orgId) return;

    const fetchProducts = async () => {
      setLoadingProducts(true);
      try {
        const cmcode = (form.customerCode || "").trim();
        // 1) เช็คของลูกค้าก่อน
        let res = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId, CMCODE: cmcode || "cmcode" },
        });

        let arr = Array.isArray(res?.data?.data) ? res.data.data : [];

        // 2) ถ้าไม่มีสินค้า -> fallback เป็น ORG
        if (!arr || arr.length === 0) {
          res = await api.get(API_GETPRODUCTS, {
            params: { ORGID: orgId, CMCODE: "ORG" },
          });
          arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        }

        setProducts(arr);
      } catch (e) {
        console.error("API_GETPRODUCTS error:", e);
        sa.error(
          e?.response?.data?.message || e?.message || "ไม่สามารถโหลดสินค้าได้",
        );
        setProducts([]);
      } finally {
        setLoadingProducts(false);
      }
    };

    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, form.customerCode]);

  // แปลง service เป็น options สำหรับ select
  const serviceOptions = useMemo(
    () =>
      services.map((s) => ({
        value: String(s.svId),
        label: `(${s.svCode}) ${s.svName}`,
        raw: s,
      })),
    [services],
  );

  // service ปัจจุบันที่เลือก
  const currentService = useMemo(
    () => services.find((s) => String(s.svId) === String(form.serviceId)),
    [services, form.serviceId],
  );

  const isPieceBased = currentService?.svType === "รายชิ้น";
  const pkgPrice = Number(currentService?.svPrice || 0);
  const pkgQty = Number(currentService?.svQty || 0);
  const currentUnit = currentService?.svUnit || "";

  // ✅ เงื่อนไขจำกัดจำนวน: svUnit เป็น "ชุด" หรือ "ตัว/ชิ้น"
  const isQtyLimitedUnit = useMemo(() => {
    if (isPieceBased) return false; // ✅ รายชิ้น ไม่ต้องคุม/เตือน
    const u = (currentService?.svUnit || "").trim();
    return u === "ชุด" || u === "ตัว/ชิ้น";
  }, [isPieceBased, currentService?.svUnit]);

  // เมื่อเลือกบริการ → set serviceId + เคลียร์ตารางรายการ
  const onServiceChange = (e) => {
    const value = e.target.value;
    setForm((s) => ({ ...s, serviceId: value }));

    // เคลียร์ฟอร์มเพิ่มรายการแบบ API
    setDetailProductId("");
    setDetailQty("");
    setDetailPrice("");
    setDetailWeight("");

    // เคลียร์รายการทั้งหมด
    setDetails([]);
  };

  // ---------- ฟิลด์เพิ่มรายการแบบ API (ด้านบน) ----------
  const [detailProductId, setDetailProductId] = useState(""); // pdId
  const [detailQty, setDetailQty] = useState(""); // จำนวน
  const [detailPrice, setDetailPrice] = useState(""); // ราคา (จาก pdPrice)

  // ---------- รายการทั้งหมดในตาราง (มีทั้ง api + custom) ----------
  const [details, setDetails] = useState([]);

  const totalQty = useMemo(() => {
    return details.reduce((sum, d) => sum + Number(d.qty || 0), 0);
  }, [details]);

  const totalWeight = useMemo(() => {
    return details.reduce(
      (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
      0,
    );
  }, [details]);

  const exceedQtyAlert = (nextQty) => {
    sa.info(
      `จำนวนรวม ${nextQty} เกินจำนวนคงเหลือ ${pkgQty} ${currentUnit || ""}`,
    );
  };

  // เมื่อเลือกสินค้า (ฟอร์มเพิ่มรายการแบบ API) → เติมราคา/น้ำหนัก
  const handleSelectProduct = (e) => {
    const val = e.target.value;
    setDetailProductId(val);

    const found = products.find((p) => String(p.pdId) === String(val));
    if (found) {
      setDetailPrice(Number(found.pdPrice || 0).toFixed(2));
      setDetailWeight(Number(found.pdWeight || 0).toFixed(2));
    } else {
      setDetailPrice("");
      setDetailWeight("");
    }
  };

  // เพิ่มรายการจาก API (ด้านบน)
  const handleAddDetail = () => {
    const qty = Number(detailQty);
    const price = Number(detailPrice);

    if (!detailProductId) return sa.info("กรุณาเลือกสินค้า");
    if (!qty || qty <= 0) return sa.info("กรุณากรอกจำนวนให้ถูกต้อง");
    if (!price || price <= 0) return sa.info("ราคาสินค้าไม่ถูกต้อง");

    // ✅ คุมจำนวนไม่ให้เกินจำนวนคงเหลือ (เฉพาะ unit ชุด/ตัว-ชิ้น)
    if (isQtyLimitedUnit && currentService) {
      const nextTotalQty = Number(totalQty) + qty;
      if (nextTotalQty > pkgQty) {
        exceedQtyAlert(nextTotalQty);
        return;
      }
    }

    const product = products.find(
      (p) => String(p.pdId) === String(detailProductId),
    );

    setDetails((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "api",
        pdId: product?.pdId,
        pdCode: product?.pdCode,
        productLabel: product?.pdName || "",
        qty,
        price: Number(product?.pdPrice || 0),
        weight: Number(product?.pdWeight || 0),
      },
    ]);

    setDetailProductId("");
    setDetailQty("");
    setDetailPrice("");
    setDetailWeight("");
  };

  // เพิ่มแถวกรอกเอง
  const handleAddCustomRow = () => {
    setDetails((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: "custom",
        productName: "",
        qty: "",
        price: "",
        weight: "",
      },
    ]);
  };

  const handleRemoveRow = (id) => {
    setDetails((prev) => prev.filter((r) => r.id !== id));
  };

  // เปลี่ยนค่าในแถว (รองรับทั้ง api/custom)
  const handleChangeRow = (id, key, value) => {
    // ✅ ถ้าแก้ qty ต้องคุมจำนวนไม่ให้เกินจำนวนคงเหลือ (เฉพาะ unit ชุด/ตัว-ชิ้น)
    if (key === "qty") {
      if (value === "") {
        setDetails((prev) =>
          prev.map((r) => (r.id === id ? { ...r, qty: "" } : r)),
        );
        return;
      }

      const nextQty = Number(value);
      if (isNaN(nextQty) || nextQty < 0) return;

      if (isQtyLimitedUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const oldQty = Number(currentRow?.qty || 0);
        const nextTotalQty = Number(totalQty) - oldQty + nextQty;

        if (nextTotalQty > pkgQty) {
          exceedQtyAlert(nextTotalQty);
          return;
        }
      }

      setDetails((prev) =>
        prev.map((r) => (r.id === id ? { ...r, qty: nextQty } : r)),
      );
      return;
    }

    // price/weight/productName
    setDetails((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [key]: value } : r)),
    );
  };

  const handleCancelAddRecordOrder = () => {
    navigate("/order-orgs");
  };

  const handleSaveBill = async () => {
    try {
      // ---------- validate พื้นฐาน ----------
      if (tnId == null || orgId == null || brId == null) {
        return sa.error("ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)");
      }

      if (!form.customerCode) return sa.info("กรุณาเลือกลูกค้า");
      if (!form.serviceId) return sa.info("กรุณาเลือกแพ็คเกจ/บริการ");
      if (!receiveDate || !dueDate)
        return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");

      // ---------- แยกแถวสินค้า: API / กรอกเอง ----------
      const apiRows = (details || []).filter((d) => !!d?.pdId);

      const customRows = (details || []).filter((d) => {
        const name = String(d?.productName || d?.productLabel || "").trim();
        return !d?.pdId && name.length > 0; // ไม่มี pdId แต่มีชื่อสินค้า (กรอกเอง)
      });

      if (apiRows.length === 0 && customRows.length === 0) {
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
      }

      // ---------- validate แถวกรอกเอง ----------
      for (const r of customRows) {
        const name = String(r?.productName || r?.productLabel || "").trim();
        const qty = Number(r?.qty || 0);
        const price = Number(r?.price || 0);
        const weight = Number(r?.weight || 0);

        if (!name) return sa.info("กรุณากรอกชื่อสินค้า (กรอกเอง)");
        if (!qty || qty <= 0)
          return sa.info(`กรุณากรอกจำนวนให้ถูกต้อง (${name})`);
        if (!price || price <= 0)
          return sa.info(`กรุณากรอกราคาให้ถูกต้อง (${name})`);
        if (weight < 0) return sa.info(`กรุณากรอกน้ำหนักให้ถูกต้อง (${name})`);
      }

      // ---------- คำนวณรวม เพื่อเช็คคงเหลือ ----------
      const totalQtyUsed =
        apiRows.reduce((s, d) => s + Number(d.qty || 0), 0) +
        customRows.reduce((s, d) => s + Number(d.qty || 0), 0);

      const totalWeightUsed =
        apiRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        ) +
        customRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        );

      // ---------- เช็คคงเหลือ (ชุด/ตัว/ชิ้น/กิโลกรัม) ----------
      if (currentService) {
        const unit = String(currentService.svUnit || "").trim();
        const remain = Number(currentService.svQty || 0);

        if (
          !isPieceBased && // ✅ เพิ่มบรรทัดนี้
          (unit === "ชุด" || unit === "ตัว/ชิ้น") &&
          remain > 0 &&
          totalQtyUsed > remain
        ) {
          return sa.info(`จำนวนเกินคงเหลือ (${remain} ${unit})`);
        }

        if (
          !isPieceBased &&
          unit === "กิโลกรัม" &&
          remain > 0 &&
          totalWeightUsed > remain
        ) {
          return sa.info(
            `น้ำหนักรวมเกินคงเหลือ (${remain.toFixed(2)} ${unit})`,
          );
        }
      }

      // ---------- 1) ถ้ามี “กรอกเอง” ให้สร้างสินค้าในระบบก่อน (API_ADDPRODUCT) ----------
      // แล้วเอา pdId ที่ได้มาใช้เป็น ITEMS เพื่อเปิดบิล
      const createdCustomItems = [];

      for (const r of customRows) {
        const NAME = String(r?.productName || r?.productLabel || "").trim();
        const PRICE = Number(r?.price || 0);
        const WEIGHT = Number(r?.weight || 0);

        const addRes = await api.post(API_ADDPRODUCT, {
          ORGID: orgId,
          CMCODE: form.customerCode,
          NAME,
          PRICE,
          WEIGHT,
        });

        const okAdd = addRes?.data?.statustext === "SUCCESS";

        // ✅ FIX: data เป็น array
        const pdId =
          addRes?.data?.data?.pdId ?? addRes?.data?.data?.[0]?.pdId ?? null;

        if (!okAdd || !pdId) {
          console.error("API_ADDPRODUCT error:", addRes?.data);
          return sa.error(
            addRes?.data?.message || `เพิ่มสินค้าไม่สำเร็จ: ${NAME}`,
          );
        }

        createdCustomItems.push({
          pdId,
          bdQty: Number(r?.qty || 0),
          pdPrice: PRICE,
          weight: WEIGHT,
        });
      }

      // ---------- 2) ต้องเรียก API_GETPRODUCTS ด้วย (หลังเพิ่มสินค้ากรอกเอง) ----------
      // ใช้เพื่อ refresh สินค้าลูกค้า (ไม่บังคับต้อง setProducts ที่นี่ก็ได้ แต่ “ต้องเรียก”)
      try {
        await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId, CMCODE: form.customerCode },
        });
      } catch (e) {
        // ไม่ให้บล็อค flow เปิดบิล
        console.warn(
          "API_GETPRODUCTS refresh after add custom failed:",
          e?.message,
        );
      }

      // ---------- 3) เตรียม ITEMS สำหรับเปิดบิล ----------
      const apiItems = apiRows
        .map((d) => ({
          pdId: d.pdId,
          bdQty: Number(d.qty || 0),
          pdPrice: Number(d.price || 0),
          weight: Number(d.weight || 0),
        }))
        .filter((it) => it.pdId && it.bdQty > 0);

      const customItems = createdCustomItems
        .map((it) => ({
          pdId: it.pdId,
          bdQty: Number(it.bdQty || 0),
          pdPrice: Number(it.pdPrice || 0),
          weight: Number(it.weight || 0),
        }))
        .filter((it) => it.pdId && it.bdQty > 0);

      const ITEMS = [...apiItems, ...customItems].map(
        ({ weight, ...rest }) => rest,
      );

      // ถ้ามีแถวในตารางแล้ว → ถือว่ามีรายการแล้ว ไม่ต้องเตือน
      if (details.length === 0) {
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
      }

      // ---------- TOTALPDWEIGHT ----------
      const totalPdWeight = [...apiItems, ...customItems].reduce(
        (sum, d) => sum + Number(d.weight || 0) * Number(d.bdQty || 0),
        0,
      );

      // ---------- 4) ยิง API_BUYSERVICEPACKAGE ก่อน ----------
      // param ตามรูป: { ORGID, CMCODE, ITEMS: [{ SVID }] }
      const buyRes = await api.post(API_BUYSERVICEPACKAGE, {
        ORGID: orgId,
        CMCODE: form.customerCode,
        ITEMS: [{ SVID: Number(form.serviceId) }],
      });

      const buyOk = buyRes?.data?.statustext === "SUCCESS";
      if (!buyOk) {
        console.error("API_BUYSERVICEPACKAGE error:", buyRes?.data);
        return sa.error(buyRes?.data?.message || "ซื้อแพ็คเกจไม่สำเร็จ");
      }

      // ---------- 5) ค่อยยิง API_CREATEBILL ----------
      const payload = {
        TNID: tnId,
        ORGID: orgId,
        BRID: brId,
        CMCODE: form.customerCode,
        SVID: form.serviceId,
        BRECEIVE: receiveDate,
        BDUEDATE: dueDate,
        DISCOUNT: 0,
        VAT: 0,
        TOTALPDWEIGHT: Number(totalPdWeight || 0).toFixed(2),
        ITEMS,
      };

      const res = await api.post(API_CREATEBILL, payload);
      const ok = res?.data?.statustext === "SUCCESS";

      if (!ok) {
        console.error("API_CREATEBILL error:", res?.data);
        return sa.error(res?.data?.message || "เปิดบิลไม่สำเร็จ");
      }

      await sa.success(res?.data?.message || "เปิดบิลสำเร็จ");
      navigate("/order-bill-org");
    } catch (e) {
      console.error("handleSaveBill exception:", e);
      sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
    }
  };

  const fetchProductsByCmCode = async (cmcode) => {
    try {
      const res = await api.get(API_GETPRODUCTS, {
        params: { ORGID: orgId, CMCODE: cmcode },
      });

      const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
      setProducts(arr);
      return arr;
    } catch (e) {
      console.error("API_GETPRODUCTS error:", e);
      setProducts([]);
      return [];
    }
  };

  return (
    <>
      {/* ✅ CSS desktop/tablet table */}
      <style>{`
        .zi-table-wrap{
          background:#fff;
          border-radius:10px;
          border:1px solid rgba(0,0,0,.06);
          overflow:hidden;
        }
        .zi-table{ margin:0; }
        .zi-table thead th{
          background:#f7fafc;
          color:#0f172a;
          font-weight:700;
          font-size:14px;
          border-bottom:1px solid rgba(0,0,0,.06);
          padding:14px 16px;
          white-space:nowrap;
        }
        .zi-table tbody td{
          padding:14px 16px;
          border-top:1px solid rgba(0,0,0,.06);
          vertical-align:middle;
          font-size:14px;
          color:#0f172a;
        }
        .zi-table tbody tr:hover{ background:#f9fbff; }
        .fw-600{ font-weight:600; }
      `}</style>

      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">เปิดบิล (ลูกค้าไม่มีแพ็คเกจ)</h6>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <Form onSubmit={(e) => e.preventDefault()}>
                  <h6 className="heading-small text-muted mb-4">
                    ข้อมูลส่วนหัว
                  </h6>

                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          ลูกค้า
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={customerDisplay}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          แพ็คเกจ
                        </label>
                        <Input
                          id="serviceSelect"
                          className="form-control-alternative"
                          type="select"
                          name="serviceId"
                          value={form.serviceId}
                          onChange={onServiceChange}
                          required
                          disabled={loadingServices || !!serviceError}
                        >
                          <option value="">
                            {loadingServices
                              ? "กำลังโหลดบริการ..."
                              : serviceError || "-- เลือก --"}
                          </option>
                          {serviceOptions.map((o) => (
                            <option key={o.value} value={o.value}>
                              {o.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่รับผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={receiveDate}
                          onChange={(e) => setReceiveDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่ส่งผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={dueDate}
                          onChange={(e) => setDueDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

                  {/* ฟอร์มเพิ่มรายการแบบ API (คงเดิม) */}
                  <Row>
                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">สินค้า</label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          name="detailProductId"
                          value={detailProductId}
                          onChange={handleSelectProduct}
                          disabled={loadingProducts || products.length === 0}
                        >
                          <option value="">
                            {loadingProducts
                              ? "-- กำลังโหลดสินค้า --"
                              : products.length === 0
                                ? "-- ไม่มีสินค้า --"
                                : "-- เลือก --"}
                          </option>
                          {products.map((p) => (
                            <option key={p.pdId} value={p.pdId}>
                              ({p.pdCode}) {p.pdName}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">จำนวนผ้า</label>
                        <Input
                          className="form-control-alternative"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          ค่าบริการต่อชิ้น (บาท)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailPrice}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          น้ำหนักต่อชิ้น (กิโลกรัม)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailWeight}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup className="mb-0">
                        <Label className="invisible">offset</Label>
                        <Button
                          color="info"
                          onClick={handleAddDetail}
                          className="w-100"
                          type="button"
                        >
                          เพิ่ม
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />

                  {/* ปุ่มเพิ่มแถวกรอกเอง */}
                  {/* <div className="d-flex justify-content-end align-items-center mb-2">
                    <Button
                      color="info"
                      type="button"
                      onClick={handleAddCustomRow}
                    >
                      + เพิ่มสินค้า (กรอกเอง)
                    </Button>
                  </div> */}

                  {/* ตารางรายการ */}
                  <Row>
                    <Col lg="12">
                      {isSmall ? (
                        <div className="table-responsive">
                          <Table
                            responsive
                            hover
                            borderless
                            className="table table-modern mb-0"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                ></th>
                              </tr>
                            </thead>

                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  const name =
                                    d.type === "custom"
                                      ? d.productName
                                      : d.productLabel;

                                  return (
                                    <tr key={d.id}>
                                      <td data-th="สินค้า">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          name || ""
                                        )}
                                      </td>

                                      <td data-th="จำนวนผ้า">
                                        <Input
                                          className="form-control-alternative"
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>

                                      <td data-th="ค่าบริการต่อชิ้น (บาท)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.price || 0).toFixed(2)
                                        )}
                                      </td>

                                      <td data-th="น้ำหนักต่อชิ้น (กิโลกรัม)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.weight || 0).toFixed(2)
                                        )}
                                      </td>

                                      <td data-th="น้ำหนักรวม (กิโลกรัม)">
                                        {Number(rowTotalWeight || 0).toFixed(2)}
                                      </td>

                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          size="sm"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="zi-table-wrap">
                          <Table responsive hover className="zi-table mb-0">
                            <thead>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                ></th>
                              </tr>
                            </thead>

                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  return (
                                    <tr key={d.id}>
                                      <td>
                                        {d.type === "custom" ? (
                                          <Input
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={d.productLabel || ""}
                                            readOnly
                                            className="form-control-alternative"
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(d.price || 0).toFixed(
                                              2,
                                            )}
                                            readOnly
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(
                                              d.weight || 0,
                                            ).toFixed(2)}
                                            readOnly
                                            disabled
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="text"
                                          value={Number(
                                            rowTotalWeight || 0,
                                          ).toFixed(2)}
                                          readOnly
                                          disabled
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Summary */}
                  <Row className="justify-content-end mt-3 mb-2">
                    <Col lg="4" md="6" className="text-right">
                      {currentService &&
                        (isPieceBased ? (
                          // ✅ svType === "รายชิ้น"
                          <div
                            style={{
                              background: "#f5f7fa",
                              padding: "12px 15px",
                              borderRadius: "8px",
                              border: "1px solid #e3e6ef",
                            }}
                          >
                            <div style={{ fontSize: 14, color: "#555" }}>
                              น้ำหนักรวมทั้งหมด (กิโลกรัม)
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: "#1f2937",
                                marginBottom: 6,
                              }}
                            >
                              {totalWeight.toFixed(2)} กิโลกรัม
                            </div>
                            <div
                              style={{
                                paddingTop: 8,
                                marginTop: 6,
                                fontSize: 14,
                                color: "#0f172a",
                              }}
                            ></div>
                          </div>
                        ) : (
                          // ✅ นอกนั้น (ไม่ใช่ "รายชิ้น")
                          <div
                            style={{
                              background: "#f5f7fa",
                              padding: "12px 15px",
                              borderRadius: "8px",
                              border: "1px solid #e3e6ef",
                            }}
                          >
                            <div style={{ fontSize: 14, color: "#555" }}>
                              ราคาแพ็คเกจ
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: "#1f2937",
                                marginBottom: 6,
                              }}
                            >
                              {pkgPrice.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                              บาท
                            </div>
                            {/* โชว์ราคาแพ็คเกจ/จำนวนคงเหลือ เมื่อ “ไม่ใช่รายชิ้น” */}
                            {!isPieceBased && currentService && (
                              <div
                                style={{
                                  borderTop: "1px dashed #cbd5e1",
                                  paddingTop: 8,
                                  marginTop: 6,
                                  fontSize: 14,
                                  color: "#0f172a",
                                }}
                              >
                                <div className="d-flex justify-content-between">
                                  <span>น้ำหนักรวมทั้งหมด (กิโลกรัม)</span>
                                  <span style={{ fontWeight: 600 }}>
                                    {totalWeight.toFixed(2)} กิโลกรัม
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between mt-1">
                                  <span>จำนวนคงเหลือ</span>
                                  <span style={{ fontWeight: 600 }}>
                                    {pkgQty.toLocaleString()} {currentUnit}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                    </Col>
                  </Row>

                  {/* ปุ่มบันทึก/ยกเลิก */}
                  <ModalFooter className="px-0">
                    <Button
                      color="secondary"
                      onClick={handleCancelAddRecordOrder}
                      type="button"
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      color="primary"
                      type="button"
                      onClick={handleSaveBill}
                    >
                      เปิดบิล
                    </Button>
                  </ModalFooter>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddRecordOrderNoPackage;
